import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-card-background" }
const _hoisted_2 = { class: "book-card-background__inner" }

import BookCover from '@/app/components/book/card/BookCover.vue'
import type { DocCoverProps } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCardBackground',
  props: {
    doc: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BookCover, {
        doc: __props.doc,
        class: "book-card-background__image"
      }, null, 8, ["doc"])
    ])
  ]))
}
}

})